export interface Anime {
  id: string;
  title: string;
  cover: string;
  banner?: string;
  description: string;
  genres: string[];
  region: string;
  year: number;
  rating: number;
  status: string;
  latestEpisode: number;
  totalEpisodes: number;
  director: string;
  updatedAt: string;
  views: number;
  featured?: boolean;
}

export const animeList: Anime[] = [
  {
    id: "star-voyager",
    title: "星海旅人",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20young%20space%20traveler%20in%20a%20sleek%20silver%20spacesuit%20standing%20before%20a%20glowing%20nebula%2C%20clean%20soft%20pastel%20background%2C%20vibrant%20cel-shaded%20anime%20illustration%2C%20cinematic%20studio%20lighting%2C%20highly%20detailed%20portrait%20composition&width=400&height=560&seq=cover-01&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Stylized%20artistic%20anime%20background%20illustration%20of%20a%20futuristic%20floating%20city%20above%20the%20clouds%20with%20glowing%20energy%20trails%20and%20pink%20cherry%20blossom%20petals%20drifting%2C%20dramatic%20sunset%20sky%2C%20epic%20wide%20cinematic%20composition%2C%20vibrant%20painterly%20style%2C%20highly%20detailed&width=1600&height=900&seq=hero-01&orientation=landscape",
    description:
      "少年维恩登上星际列车，只为寻找失落的故乡星球。沿途的每一颗星，都是一段未解的故事。这是一部关于远行、羁绊与归途的科幻成长物语。",
    genres: ["科幻", "冒险"],
    region: "日本",
    year: 2024,
    rating: 9.2,
    status: "连载中",
    latestEpisode: 12,
    totalEpisodes: 24,
    director: "高桥悠介",
    updatedAt: "2026-10-12",
    views: 1580000,
    featured: true,
  },
  {
    id: "flame-sword",
    title: "烈焰剑心",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20young%20swordsman%20holding%20a%20blazing%20flame%20katana%2C%20clean%20soft%20pastel%20background%2C%20vibrant%20cel-shaded%20anime%20illustration%2C%20cinematic%20studio%20lighting%2C%20highly%20detailed%20portrait%20composition&width=400&height=560&seq=cover-02&orientation=portrait",
    description:
      "失去记忆的剑士携一把燃着业火的刀，踏上讨伐魔将的旅途。刀锋所过之处，是他逐渐找回的名字。热血与友情交织的冒险史诗。",
    genres: ["热血", "奇幻"],
    region: "日本",
    year: 2023,
    rating: 8.7,
    status: "已完结",
    latestEpisode: 26,
    totalEpisodes: 26,
    director: "佐藤健一",
    updatedAt: "2026-09-20",
    views: 1420000,
  },
  {
    id: "sakura-promise",
    title: "樱花之约",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20girl%20in%20a%20school%20uniform%20under%20blooming%20cherry%20blossom%20trees%2C%20clean%20soft%20pastel%20background%2C%20vibrant%20cel-shaded%20anime%20illustration%2C%20cinematic%20studio%20lighting%2C%20highly%20detailed%20portrait%20composition&width=400&height=560&seq=cover-03&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Stylized%20artistic%20anime%20background%20of%20a%20magical%20cherry%20blossom%20avenue%20at%20dusk%20with%20glowing%20lanterns%20and%20drifting%20petals%2C%20warm%20pink%20and%20orange%20tones%2C%20dreamy%20atmosphere%2C%20wide%20cinematic%20composition%2C%20painterly%20illustration%2C%20highly%20detailed&width=1600&height=900&seq=hero-02&orientation=landscape",
    description:
      "每年樱花盛开时，她都会在旧车站等一个约定。青春里最温柔的错过与重逢，都在这一季的花落之间。细腻动人的校园恋爱故事。",
    genres: ["恋爱", "校园"],
    region: "日本",
    year: 2024,
    rating: 8.9,
    status: "连载中",
    latestEpisode: 9,
    totalEpisodes: 12,
    director: "小林美咲",
    updatedAt: "2026-10-13",
    views: 1330000,
    featured: true,
  },
  {
    id: "blue-era",
    title: "苍蓝纪元",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20futuristic%20pilot%20in%20a%20high-tech%20cockpit%20surrounded%20by%20holographic%20data%2C%20clean%20soft%20pastel%20background%2C%20vibrant%20cel-shaded%20anime%20illustration%2C%20cinematic%20studio%20lighting%2C%20highly%20detailed%20portrait%20composition&width=400&height=560&seq=cover-04&orientation=portrait",
    description:
      "当天空被钢铁穹顶封锁，一群少年驾驶实验机甲试图重新看见星空。冰冷科技与滚烫理想碰撞，悬念丛生的国产科幻力作。",
    genres: ["科幻", "悬疑"],
    region: "中国",
    year: 2023,
    rating: 9.0,
    status: "已完结",
    latestEpisode: 24,
    totalEpisodes: 24,
    director: "陈墨",
    updatedAt: "2026-08-30",
    views: 1210000,
  },
  {
    id: "destiny-echo",
    title: "命运回响",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20magician%20girl%20casting%20a%20glowing%20runic%20spell%2C%20clean%20soft%20pastel%20background%2C%20vibrant%20cel-shaded%20anime%20illustration%2C%20cinematic%20studio%20lighting%2C%20highly%20detailed%20portrait%20composition&width=400&height=560&seq=cover-05&orientation=portrait",
    description:
      "古老的预言再次响起，平凡的少年被卷入王国的命运漩涡。他所做的每一个选择，都会在多年后以回响的形式归来。",
    genres: ["奇幻", "热血"],
    region: "日本",
    year: 2022,
    rating: 8.5,
    status: "已完结",
    latestEpisode: 25,
    totalEpisodes: 25,
    director: "山田翔",
    updatedAt: "2026-07-15",
    views: 980000,
  },
  {
    id: "summer-unnamed",
    title: "夏日未名",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20two%20high%20school%20students%20riding%20bikes%20at%20a%20seaside%20town%20in%20summer%2C%20clean%20soft%20pastel%20background%2C%20vibrant%20cel-shaded%20anime%20illustration%2C%20cinematic%20studio%20lighting%2C%20highly%20detailed%20portrait%20composition&width=400&height=560&seq=cover-06&orientation=portrait",
    description:
      "那个夏天没有名字，风很咸，蝉很吵，而她笑得很近。一段关于青春、海浪与朦胧心意的夏日叙事。",
    genres: ["校园", "恋爱"],
    region: "日本",
    year: 2024,
    rating: 8.3,
    status: "连载中",
    latestEpisode: 7,
    totalEpisodes: 12,
    director: "田中由美",
    updatedAt: "2026-10-11",
    views: 760000,
  },
  {
    id: "iron-mecha",
    title: "铁血机甲",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20giant%20battle%20mecha%20robot%20standing%20in%20a%20ruined%20city%20with%20sparks%2C%20clean%20soft%20pastel%20background%2C%20vibrant%20cel-shaded%20anime%20illustration%2C%20cinematic%20studio%20lighting%2C%20highly%20detailed%20portrait%20composition&width=400&height=560&seq=cover-07&orientation=portrait",
    description:
      "战争结束后的第十年，退役驾驶员再次被召回驾驶舱。钢铁之下藏着人性最后的温度，硬核机甲战斗番的代表作。",
    genres: ["热血", "科幻"],
    region: "日本",
    year: 2021,
    rating: 8.8,
    status: "已完结",
    latestEpisode: 39,
    totalEpisodes: 39,
    director: "中村刚",
    updatedAt: "2026-06-02",
    views: 1120000,
  },
  {
    id: "hidden-forest",
    title: "神隐之森",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20small%20forest%20spirit%20beside%20a%20girl%20in%20a%20mystical%20glowing%20woods%2C%20clean%20soft%20pastel%20background%2C%20vibrant%20cel-shaded%20anime%20illustration%2C%20cinematic%20studio%20lighting%2C%20highly%20detailed%20portrait%20composition&width=400&height=560&seq=cover-08&orientation=portrait",
    description:
      "迷路的孩子走进森林深处，遇见了只在黄昏出现的守林人。治愈系奇幻童话，每一帧都像会呼吸的水彩画。",
    genres: ["奇幻", "治愈"],
    region: "日本",
    year: 2023,
    rating: 9.1,
    status: "已完结",
    latestEpisode: 13,
    totalEpisodes: 13,
    director: "宫崎绫",
    updatedAt: "2026-05-18",
    views: 890000,
  },
  {
    id: "time-letter",
    title: "时光信笺",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20girl%20writing%20a%20letter%20by%20a%20window%20with%20warm%20sunset%20light%2C%20clean%20soft%20pastel%20background%2C%20vibrant%20cel-shaded%20anime%20illustration%2C%20cinematic%20studio%20lighting%2C%20highly%20detailed%20portrait%20composition&width=400&height=560&seq=cover-09&orientation=portrait",
    description:
      "如果能把信寄到十年前，你最想对谁说话？跨越时间的书信往返，串起两代人的遗憾与和解。经久不衰的治愈经典。",
    genres: ["治愈", "经典"],
    region: "日本",
    year: 2018,
    rating: 9.3,
    status: "已完结",
    latestEpisode: 12,
    totalEpisodes: 12,
    director: "新海诚司",
    updatedAt: "2026-04-10",
    views: 1050000,
  },
  {
    id: "dragon-chronicle",
    title: "龙纹战纪",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20young%20dragon%20rider%20with%20a%20glowing%20dragon%20mark%20on%20his%20arm%2C%20clean%20soft%20pastel%20background%2C%20vibrant%20cel-shaded%20anime%20illustration%2C%20cinematic%20studio%20lighting%2C%20highly%20detailed%20portrait%20composition&width=400&height=560&seq=cover-10&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Stylized%20artistic%20anime%20background%20of%20a%20mystical%20glowing%20forest%20with%20floating%20light%20particles%20and%20ancient%20tree%20spirits%2C%20emerald%20and%20warm%20amber%20tones%2C%20ethereal%20atmosphere%2C%20wide%20cinematic%20composition%2C%20painterly%20illustration%2C%20highly%20detailed&width=1600&height=900&seq=hero-03&orientation=landscape",
    description:
      "龙纹是天选者的烙印，也是被追杀的罪名。少年背负禁忌之力，踏上寻找龙族真相的征途。国产热血长篇巨制。",
    genres: ["热血", "奇幻"],
    region: "中国",
    year: 2022,
    rating: 8.6,
    status: "连载中",
    latestEpisode: 30,
    totalEpisodes: 48,
    director: "李云",
    updatedAt: "2026-10-10",
    views: 1340000,
    featured: true,
  },
  {
    id: "moonlight-cafe",
    title: "月光咖啡馆",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20barista%20girl%20in%20a%20cozy%20moonlit%20cafe%20with%20warm%20lamps%2C%20clean%20soft%20pastel%20background%2C%20vibrant%20cel-shaded%20anime%20illustration%2C%20cinematic%20studio%20lighting%2C%20highly%20detailed%20portrait%20composition&width=400&height=560&seq=cover-11&orientation=portrait",
    description:
      "只在深夜营业的咖啡馆，接待的客人心里都藏着一句话说不出口。一杯拿铁的时间，或许就能改变一段关系。",
    genres: ["恋爱", "治愈"],
    region: "韩国",
    year: 2024,
    rating: 8.4,
    status: "连载中",
    latestEpisode: 10,
    totalEpisodes: 16,
    director: "金智恩",
    updatedAt: "2026-10-09",
    views: 680000,
  },
  {
    id: "end-city",
    title: "终焉之城",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20detective%20in%20a%20rainy%20neon%20dystopian%20city%20at%20night%2C%20clean%20soft%20pastel%20background%2C%20vibrant%20cel-shaded%20anime%20illustration%2C%20cinematic%20studio%20lighting%2C%20highly%20detailed%20portrait%20composition&width=400&height=560&seq=cover-12&orientation=portrait",
    description:
      "城市即将在七天后沉没。侦探与唯一的证人必须在倒计时结束前，找到那个被所有人遗忘的真相。悬疑科幻神作。",
    genres: ["科幻", "悬疑"],
    region: "日本",
    year: 2023,
    rating: 9.0,
    status: "连载中",
    latestEpisode: 18,
    totalEpisodes: 24,
    director: "石井凉",
    updatedAt: "2026-10-12",
    views: 970000,
  },
  {
    id: "wind-dance",
    title: "风之剑舞",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20retro%20style%20samurai%20girl%20wielding%20a%20sword%20in%20the%20wind%2C%20clean%20soft%20pastel%20background%2C%20vibrant%20cel-shaded%20anime%20illustration%2C%20cinematic%20studio%20lighting%2C%20highly%20detailed%20portrait%20composition&width=400&height=560&seq=cover-13&orientation=portrait",
    description:
      "被奉为剑道神话的少女，用十年时间只为完成一场注定输掉的比试。跨越时代的经典热血之作，至今仍被反复重温。",
    genres: ["经典", "热血"],
    region: "日本",
    year: 2015,
    rating: 9.4,
    status: "已完结",
    latestEpisode: 50,
    totalEpisodes: 50,
    director: "渡边纯",
    updatedAt: "2026-03-01",
    views: 1520000,
  },
  {
    id: "stardust-tale",
    title: "星尘物语",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20boy%20holding%20a%20glowing%20star%20fragment%20in%20a%20starlit%20field%2C%20clean%20soft%20pastel%20background%2C%20vibrant%20cel-shaded%20anime%20illustration%2C%20cinematic%20studio%20lighting%2C%20highly%20detailed%20portrait%20composition&width=400&height=560&seq=cover-14&orientation=portrait",
    description:
      "每一颗坠落的流星，都是一段被遗忘的记忆。少年拾起星尘，也拾起了整个宇宙的秘密。经久难忘的科幻经典。",
    genres: ["经典", "科幻"],
    region: "日本",
    year: 2019,
    rating: 9.2,
    status: "已完结",
    latestEpisode: 26,
    totalEpisodes: 26,
    director: "铃木遥",
    updatedAt: "2026-02-14",
    views: 1180000,
  },
  {
    id: "phantom-ninja",
    title: "幻影忍者传说",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20masked%20ninja%20leaping%20across%20rooftops%20with%20smoke%20bombs%2C%20clean%20soft%20pastel%20background%2C%20vibrant%20cel-shaded%20anime%20illustration%2C%20cinematic%20studio%20lighting%2C%20highly%20detailed%20portrait%20composition&width=400&height=560&seq=cover-15&orientation=portrait",
    description:
      "五个性格迥异的忍者少年，守护着最后一座影之城。刀光暗影之间，是成长、是背叛，也是永不熄灭的兄弟情。",
    genres: ["热血", "奇幻"],
    region: "美国",
    year: 2020,
    rating: 8.2,
    status: "已完结",
    latestEpisode: 20,
    totalEpisodes: 20,
    director: "艾瑞克·李",
    updatedAt: "2026-01-08",
    views: 720000,
  },
  {
    id: "blue-sky-oath",
    title: "青空约定",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20couple%20making%20a%20pinky%20promise%20under%20a%20vast%20blue%20sky%20on%20a%20rooftop%2C%20clean%20soft%20pastel%20background%2C%20vibrant%20cel-shaded%20anime%20illustration%2C%20cinematic%20studio%20lighting%2C%20highly%20detailed%20portrait%20composition&width=400&height=560&seq=cover-16&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Stylized%20artistic%20anime%20background%20of%20a%20rooftop%20under%20a%20vast%20summer%20sky%20with%20fireworks%20and%20a%20distant%20seaside%20town%2C%20vivid%20warm%20tones%2C%20nostalgic%20atmosphere%2C%20wide%20cinematic%20composition%2C%20painterly%20illustration%2C%20highly%20detailed&width=1600&height=900&seq=hero-04&orientation=landscape",
    description:
      "毕业那天，他们约好在最高的楼顶再见。多年以后，一个人还记得，另一个人还在路上。温柔的青春恋爱新番。",
    genres: ["恋爱", "校园"],
    region: "日本",
    year: 2025,
    rating: 8.7,
    status: "连载中",
    latestEpisode: 5,
    totalEpisodes: 12,
    director: "松本光",
    updatedAt: "2026-10-13",
    views: 540000,
  },
];

export const genreOptions: string[] = [
  "全部",
  "热血",
  "恋爱",
  "科幻",
  "经典",
  "奇幻",
  "校园",
  "治愈",
  "悬疑",
];

export const regionOptions: string[] = ["全部", "日本", "中国", "韩国", "美国"];

export const yearOptions: string[] = ["全部", "2025", "2024", "2023", "2022", "2021", "2019", "2018", "2015"];

export const sortOptions: string[] = ["最新", "最热", "评分"];